import { useQuery } from '@tanstack/react-query'
import { fetchCurrentTick, tickKeys } from '@/services/ticks'
import type { Tick } from '@/types'

/**
 * Hook to get the current (most recent) tick for a world.
 *
 * Returns the tick data including tick_number, status, and timestamps.
 *
 * @param worldId - The world to check (optional, hook is disabled if undefined)
 * @returns Object with tick data, plus loading/error states
 */
export function useCurrentTick(worldId: string | undefined) {
  const query = useQuery({
    queryKey: tickKeys.current(worldId!),
    queryFn: () => fetchCurrentTick(worldId!),
    enabled: !!worldId,
    // Refetch every 30 seconds to keep countdown accurate
    refetchInterval: 30000,
  })

  return {
    tick: query.data as Tick | null | undefined,
    tickNumber: query.data?.tick_number ?? 0,
    status: query.data?.status ?? 'pending',
    completedAt: query.data?.completed_at,
    isLoading: query.isLoading,
    error: query.error,
  }
}
